var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumb_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99935 1.33333H3.99935C3.44602 1.33333 2.97268 1.66666 2.77268 2.14666L0.759349 6.84666C0.699349 7 0.666016 7.16 0.666016 7.33333V8.66666C0.666016 9.39999 1.26602 10 1.99935 10H6.20602L5.57268 13.0467L5.55268 13.26C5.55268 13.5333 5.66602 13.7867 5.84602 13.9667L6.55268 14.6667L10.946 10.2733C11.186 10.0333 11.3327 9.7 11.3327 9.33333V2.66666C11.3327 1.93333 10.7327 1.33333 9.99935 1.33333ZM9.99935 9.33333L7.10602 12.2267L7.99935 8.66666H1.99935V7.33333L3.99935 2.66666H9.99935V9.33333ZM12.666 1.33333H15.3327V9.33333H12.666V1.33333Z",
    fill: "#5B6670"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/ThumbDown.d9c765941fa630cb4c833e6ac27d38ee.svg";
export { ForwardRef as ReactComponent };